import { getColorWithAlpha, isDarkColor } from '@elfsight/lib-utils';
import type { PollSettings } from '../../types';

export function EmptyMessage({
  textColor
}: {
  textColor: PollSettings['textColor'];
}) {
  const color = isDarkColor(textColor)
    ? getColorWithAlpha(textColor, 0.5)
    : getColorWithAlpha(textColor, 0.7);

  return (
    <div style={{ color, textAlign: 'center' }}>
      Your poll is empty. Add a question and options to get started.
    </div>
  );
}
